"use client";

import { createContext, useContext } from "react";

export type CanvasRenderProfile = {
  viewOnly: boolean;
  blueprint: boolean;
  /** Embedded summaries can keep the battery readout beside the drawing. */
  showBatteryDetails?: boolean;
  /** Harness/connection overviews have no validated load or conductor model. */
  connectionOverview?: boolean;
  /** Public showcases omit cable annotations without changing editor preferences. */
  hideCableLabels?: boolean;
};

const CanvasRenderProfileContext = createContext<CanvasRenderProfile>({
  viewOnly: false,
  blueprint: false,
});

export const CanvasRenderProfileProvider = CanvasRenderProfileContext.Provider;

export function useCanvasViewOnly(): boolean {
  return useContext(CanvasRenderProfileContext).viewOnly;
}

export function useCanvasBlueprint(): boolean {
  return useContext(CanvasRenderProfileContext).blueprint;
}

export function useCanvasBatteryDetails(): boolean {
  return useContext(CanvasRenderProfileContext).showBatteryDetails ?? true;
}

export function useCanvasConnectionOverview(): boolean {
  return useContext(CanvasRenderProfileContext).connectionOverview ?? false;
}

export function useCanvasHideCableLabels(): boolean {
  return useContext(CanvasRenderProfileContext).hideCableLabels ?? false;
}

// Opt-in override: `cable-edge.tsx` otherwise drops the metric pills below 1024 px.
const CanvasMetricPillsContext = createContext<boolean>(false);

export const CanvasMetricPillsProvider = CanvasMetricPillsContext.Provider;

export function useCanvasForceMetricPills(): boolean {
  return useContext(CanvasMetricPillsContext);
}
